import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ListService, UserGroupPermissionListComponent, UserGroupPermissionListService } from '@spartacus/organization/administration/components';
import { EfaSubListComponent } from '../efa-sub-list/efa-sub-list.component';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-user-group-permission-list',
    templateUrl: './efa-user-group-permission-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'content-wrapper' },
    providers: [
        {
            provide: ListService,
            useExisting: UserGroupPermissionListService,
        },
    ],
    imports: [EfaSubListComponent, RouterLink, TranslatePipe]
})
export class EfaUserGroupPermissionListComponent extends UserGroupPermissionListComponent implements OnInit {


  ngOnInit(): void {
  }

}
